<template>
<div>
    <div class="full">
        <div class="mainheader">
            <div class="half">
                {{ $t('pages.employeeData.skills') }}
            </div>
            <!-- <div class="half right">
                <div class="full">
                    <b-button style="display: inline;" pill variant="outline-success" @click="openNewAvailabilityPopup($event)">
                        <i class="fas fa-plus"></i>&nbsp;&nbsp;Verfügbarkeit
                    </b-button>
                    <b-button style="display: inline; margin-left: 8px;" pill variant="outline-success" @click="openNewSkillPopup($event)">
                        <i class="fas fa-plus"></i>&nbsp;&nbsp;Skill
                    </b-button>
                </div>
            </div> -->
        </div>
    </div>
    <div class="full">
        <div class="header">
            <div class="label">{{ $t('pages.employeeContext.availabilities') }}</div>
        </div>
        <employee-availability-editor :availabilities="employeeavailabilities" :employee-id="employee.id"
                                      @availabilitySelected="openEditAvailabilityPopup"/>
        <div v-for="av in availabilities" v-bind:key="av.id" class="full split-bottom-tight mb-4">
            <div class="fourth">
                <div class="label">{{ dayNumsToDisplayString(av.weekDays) }}</div>
            </div>
            <div class="fourth">
                <div class="label">{{ avInfoDisplayStringTime(av) }}&nbsp;&middot;&nbsp;{{ avInfoDisplayStringType(av) }}</div>
            </div>
            <div class="fourth">
                <div class="label data">{{ av.comment || '&nbsp;' }}</div>
            </div>
            <div class="fourth">
                <b-button style="display: inline; width: 28px; height: 28px; margin-top: -4px; margin-right: 8px;" size="sm" pill variant="warning" @click="openEditAvailabilityPopup($event, av)">
                    <i class="fas fa-edit" style="margin-left: -1px;"></i>
                </b-button>
                <b-button style="display: inline; width: 28px; height: 28px; margin-top: -4px;" size="sm" pill variant="danger" @click="deleteEmployeeAvailability(av)">
                    <i class="fas fa-trash" style="margin-left: -1px;"></i>
                </b-button>
            </div>
        </div>
    </div>
    <div class="full">
        <div class="header">
            <div class="label">{{ $t('pages.employeeContext.skills') }}</div>
        </div>
        <div v-for="s in employeeskills" v-bind:key="s.id" class="full split-bottom-tight">
            <div class="fourth">
                <div class="label">{{ skillName(s) }}</div>
            </div>
            <div class="fourth">
                <div class="label data">{{ s.value }}</div>
            </div>
            <div class="fourth">
                <div class="label">&nbsp;</div>
            </div>
            <div class="fourth">
                <b-button style="display: inline; width: 28px; height: 28px; margin-top: -4px; margin-right: 8px;" size="sm" pill variant="warning" @click="openEditSkillPopup($event, s)">
                    <i class="fas fa-edit" style="margin-left: -1px;"></i>
                </b-button>
                <b-button v-bind:class="{disabled2: s.skillId == mainSkill || s.skillId == mainUnitSkill}" style="display: inline; width: 28px; height: 28px; margin-top: -4px;" size="sm" pill variant="danger" @click="deleteEmployeeSkill(s)">
                    <i class="fas fa-trash" style="margin-left: -1px;"></i>
                </b-button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import EmployeeAvailabilityEditor from './EmployeeAvailabilityEditor';
import moment from "moment";

export default {
    components: {
        EmployeeAvailabilityEditor,
    },
    name: 'employeeavailabilityskills',
    data() {
        return {
            dataFiltered: [],
            loading: true,

        }
    },
    watch: {
        employee: {
            deep: true,
            handler (val, oldVal){
                /* this.$forceUpdate(); */
            }
        }
    },
    props: [
        "uiData",
        "employee",
        "allskills",
        "spots",
        "employeeskills",
        "employeeavailabilities"
    ],
    created() {

        this.$helpers.log(this, 'allskills, employeeskills', [this.allskills,this.employeeskills]);
    },
    destroyed() {

    },
    computed: {
        mainSkill: function(){
            let spotSkillMap = {};
            this.spots.forEach(spot => {
                spotSkillMap[spot.id] = spot.requiredSkill;
            });
            let ms = null;
            if(this.employee.spotId){
                ms = spotSkillMap[this.employee.spotId];
            }
            return ms;
        },
        mainUnitSkill:  function(){
            let mainUnit = null;
            this.spots.forEach(spot => {
                if(spot.id == this.employee.spotId){
                    mainUnit = spot.unitId;
                }
            });
            let mainUnitSkill = null;
            this.spots.forEach(spot => {

                if(spot.unitId == mainUnit && spot.isMain){
                    mainUnitSkill = spot.requiredSkill;
                }
            });
            return mainUnitSkill;
        },
        availabilities() {
            return [ ...this.employeeavailabilities ]
                .sort((a, b) => {
                    if (a.state < b.state) return -1;
                    if (a.state > b.state) return 1;
                    // if (a.weekDays.length < b.weekDays.length) return -1;
                    // if (a.weekDays.length > b.weekDays.length) return 1;
                    if (a.weekDays[0] < b.weekDays[0]) return -1;
                    if (a.weekDays[0] > b.weekDays[0]) return 1;
                    let aFrom = typeof a.from === 'string' ? moment(a.from, 'HH:mm') : moment(a.from);
                    let bFrom = typeof b.from === 'string' ? moment(b.from, 'HH:mm') : moment(b.from);
                    if (aFrom < bFrom) return -1;
                    if (aFrom > bFrom) return 1;
                    return 0;
                });
        },
    },
    methods: {
        openNewAvailabilityPopup($event){
            let view = this;
            let from = this.$helpers.getMomentTZ().hours(8).minutes(0);
            let to = this.$helpers.getMomentTZ().hours(16).minutes(0);

            let avStates = [
                { label: view.$t('pages.comp.available'), label_en: 'Available', value: 0 },
            ];
            view.uiData.employeeAvailabilityStates.filter(s => s.selectable).forEach(s => {
                s.label_en = s.label;
                s.label = s.label_de;
                s.value = s.id;
                avStates.push(s);
            });

            let dataEntries = [
                /* {label: 'Group Id', key: 'groupId', hidden: true, type: '', value: shiftTemplateGroup.id}, */
                {label: view.$t('global.general.from').toLowerCase(), key: 'from', hidden: false, type: 'timeframe', value: from, flexGroup: true, timeBig: true, startTime: true, focusProceedKey: 'to'},
                {label: view.$t('global.general.to').toLowerCase(), key: 'to', hidden: false, type: 'timeframe', value: to, flexGroup: true, timeBig: true, endTime: true},
                {divider: true},
                {key: 'state', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: true, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: avStates,
                    selectMultiple: false,
                    selectFirst: true,
                    selectedItems: [],
                    selectedItem: {},
                    onceSelected: function ($event, item, searchbar){
                    },
                    styleLight: true,
                    placeholder: view.$t('global.ui.selectType'),
                }, styles: {width: '342px', margin: '8px 0px 0px 0px'}},
                {flexDivider: true},
                /* {label: 'Anzahl', key: 'count', hidden: false, type: 'numeric', value: 1, min: 1, max: 10},
                {label: 'Pausenzeit', key: 'breakValue', hidden: false, type: 'numeric', min: 0, value: 30, max: 1440},
                {label: 'Skill Multiplier', key: 'skillMultiplier', hidden: true, type: '', value: 1},
                {label: 'Work Value Multiplier', key: 'workValueMultiplier', hidden: true, type: '', value: 1}, */
                {key: 'weekDays', hidden: false, flexGroup: true, type: 'togglelist', toggleEntries: [
                        {label: view.$t('store.openingHours.weekDay1Short'), value: 1, selected: false},
                        {label: view.$t('store.openingHours.weekDay2Short'), value: 2, selected: false},
                        {label: view.$t('store.openingHours.weekDay3Short'), value: 3, selected: false},
                        {label: view.$t('store.openingHours.weekDay4Short'), value: 4, selected: false},
                        {label: view.$t('store.openingHours.weekDay5Short'), value: 5, selected: false},
                        {label: view.$t('store.openingHours.weekDay6Short'), value: 6, selected: false},
                        {label: view.$t('store.openingHours.weekDay7Short'), value: 7, selected: false},
                    ], styles: {width: '342px'}
                },
                {divider: true, styles: {'margin-bottom': '23px'}},
                {label: view.$t('global.general.comment') + ': ', key: 'comment', hidden: false, type: 'text', value: '', length: 20},
                {flexDivider: true, styles: {'margin-bottom': '23px'}},
            ];

            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                pointerDirection: 0,
                componentState: {
                    entries: dataEntries,
                    errorCheck: [
                        (entries) => {
                            if(entries['state'] == null){
                                return {key: 'state', type: 'error', label: view.$t('global.notifications.error'), text: view.$t('workBalance.extraPay.selectTypeMin')}
                            } else if (!entries['weekDays'] || entries['weekDays'].length === 0) {
                                return {key: 'weekDays', type: 'error', label: view.$t('global.notifications.error'), text: view.$t('pages.comp.pleaseSelectWeekdayMin')}
                            } else {
                                return null
                            }
                        },

                    ],
                    selectCallback: function (av) {
                        if ((av.weekDays || []).length === 0) {
                            return;
                        }
                        if (av.state !== 0) {
                            view.createEmployeeAvailability(av);
                            return;
                        }

                        if (av.from.hours() * 60 + av.from.minutes() > 0) {
                            const startAvailability = {
                                from: av.to <= av.from
                                    ? av.to
                                    : moment().hours(0).minutes(0),
                                to: av.from,
                                state: 1,
                                weekDays: av.weekDays,
                                comment: av.comment,
                            }
                            view.createEmployeeAvailability(startAvailability);
                        }
                        if (av.to.hours() * 60 + av.to.minutes() > 0 && av.to > av.from) {
                            const endAvailability = {
                                from: av.to,
                                to: moment().hours(0).minutes(0),
                                state: 1,
                                weekDays: av.weekDays,
                                comment: av.comment,
                            }
                            view.createEmployeeAvailability(endAvailability);
                        }
                        for (const av2 of view.employeeavailabilities) {
                            const av2From = this.$helpers.getMomentFromStringTZ(av2.from, 'HH:mm');
                            const av2To = this.$helpers.getMomentFromStringTZ(av2.to, 'HH:mm');

                            const matchingWds = av2.weekDays.filter(wd => av.weekDays.includes(wd));
                            const differentWds = av2.weekDays.filter(day => !av.weekDays.includes(day));

                            if (matchingWds.length === 0) continue;

                            if (differentWds.length > 0) {
                                view.updateEmployeeAvailability({
                                    ...av2,
                                    from: av2From,
                                    to: av2To,
                                    weekDays: differentWds,
                                });
                            } else {
                                view.deleteEmployeeAvailability(av2);
                            }
                        }
                    }
                },
                header: view.$t('pages.comp.newAvailability'),
                remainAfterSelect: false,
                expanded: true,
            });
        },
        openEditAvailabilityPopup($event, a){

            let view = this;
            let from = this.$helpers.getMomentFromStringTZ(a.from, 'HH:mm');
            let to = this.$helpers.getMomentFromStringTZ(a.to, 'HH:mm');

            let avStates = [];
            let selectedAvState = {};
            view.uiData.employeeAvailabilityStates.filter(s => s.selectable).forEach(s => {
                s.label_en = s.label;
                s.label = s.label_de;
                s.value = s.id;
                avStates.push(s);
                if(s.id == a.state){
                    selectedAvState = s;
                }
            });



            let dataEntries = [
                /* {label: 'Group Id', key: 'groupId', hidden: true, type: '', value: shiftTemplateGroup.id}, */
                {label: this.$t('global.general.from').toLowerCase(), key: 'from', hidden: false, type: 'timeframe', value: from, flexGroup: true, timeBig: true, startTime: true},
                {label: this.$t('global.general.to').toLowerCase(), key: 'to', hidden: false, type: 'timeframe', value: to, flexGroup: true, timeBig: true, endTime: true},
                {divider: true},
                {label: 'employeeId', key: 'employeeId', hidden: true, value: this.employee.id},
                {label: 'id', key: 'id', hidden: true, value: a.id},
                {key: 'state', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: true, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: avStates,
                    selectMultiple: false,
                    selectedItems: [],
                    selectedItem: selectedAvState,
                    onceSelected: function ($event, item, searchbar){
                    },
                    styleLight: true,
                    placeholder: this.$t('global.ui.selectType'),
                }, styles: {width: '342px', margin: '8px 0px 0px 0px'}},
                {flexDivider: true},
                /* {label: 'Anzahl', key: 'count', hidden: false, type: 'numeric', value: 1, min: 1, max: 10},
                {label: 'Pausenzeit', key: 'breakValue', hidden: false, type: 'numeric', min: 0, value: 30, max: 1440},
                {label: 'Skill Multiplier', key: 'skillMultiplier', hidden: true, type: '', value: 1},
                {label: 'Work Value Multiplier', key: 'workValueMultiplier', hidden: true, type: '', value: 1}, */
                {key: 'weekDays', hidden: false, flexGroup: true, type: 'togglelist', toggleEntries: [
                        {label:this.$t('store.openingHours.weekDay1Short'), value: 1, selected: a.weekDays.includes(1)},
                        {label:this.$t('store.openingHours.weekDay2Short'), value: 2, selected: a.weekDays.includes(2)},
                        {label:this.$t('store.openingHours.weekDay3Short'), value: 3, selected: a.weekDays.includes(3)},
                        {label:this.$t('store.openingHours.weekDay4Short'), value: 4, selected: a.weekDays.includes(4)},
                        {label:this.$t('store.openingHours.weekDay5Short'), value: 5, selected: a.weekDays.includes(5)},
                        {label:this.$t('store.openingHours.weekDay6Short'), value: 6, selected: a.weekDays.includes(6)},
                        {label:this.$t('store.openingHours.weekDay7Short'), value: 7, selected: a.weekDays.includes(7)},
                    ], styles: {width: '342px'}
                },
                {divider: true, styles: {'margin-bottom': '23px'}},
                {label: this.$t('global.general.comment') + ': ', key: 'comment', hidden: false, type: 'text', value: a.comment, length: 20},
                {flexDivider: true, styles: {'margin-bottom': '23px'}},
            ];

            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                pointerDirection: 0,
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (av) {
                        if ((av.weekDays || []).length === 0) {
                            view.deleteEmployeeAvailability(av);
                        } else {
                            view.updateEmployeeAvailability(av);
                        }
                    }
                },
                header: view.$t('pages.comp.editAvailability'),
                remainAfterSelect: false,
                expanded: true,
            });
        },
        openNewSkillPopup($event){
            let view = this;
            let skills = [];
            view.allskills.forEach(s => {
                console.log(s);
                s.label = s.name;
                s.value = s.id;
                skills.push(s);
            });
            let dataEntries = [
                /* {label: 'Group Id', key: 'groupId', hidden: true, type: '', value: shiftTemplateGroup.id}, */
                {key: 'skillId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: true, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: skills,
                    selectMultiple: false,
                    selectedItems: [],
                    selectedItem: {},
                    onceSelected: function ($event, item, searchbar){
                    },
                    styleLight: true,
                    placeholder: view.$t('pages.comp.selectSkill'),
                }, styles: {width: '342px'}},
                {flexDivider: true},
                {label: view.$t('pages.comp.skillValue') + ': ', key: 'value', hidden: false, type: 'slider', value: 5, slider: {min: 1, max: 10,
                     value: 5, labelled: true, step: 1, inputControl: true, sliderInput: (x) => {return x}}},
                /* {label: 'Pausenzeit', key: 'breakValue', hidden: false, type: 'numeric', min: 0, value: 30, max: 1440},
                {label: 'Skill Multiplier', key: 'skillMultiplier', hidden: true, type: '', value: 1},
                {label: 'Work Value Multiplier', key: 'workValueMultiplier', hidden: true, type: '', value: 1}, */
                {flexDivider: true, styles: {'margin-bottom': '23px'}},
            ];

            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                pointerDirection: 0,
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (newSkill) {
                        view.createEmployeeSkill(newSkill);
                    }
                },
                header: view.$t('store.structure.newSkill'),
                width: '600px',
                remainAfterSelect: false,
                expanded: true,
            });
        },
        openEditSkillPopup($event, s){
            console.log(this, 'Edit Popup for SKILL', s, false);
            let view = this;
            let dataEntries = [
                {label: 'EmployeeSkill ID', key: 'id', hidden: true, type: '', value: s.id},
                {label: 'Employee ID', key: 'employeeId', hidden: true, type: '', value: s.employeeId},
                {label: 'Skill ID', key: 'skillId', hidden: true, type: '', value: s.skillId},
                {label: view.$t('pages.comp.skillValue') + ': ', key: 'value', hidden: false, type: 'slider', value: s.value, slider: {min: 1,
                        value: s.value, max: 10, labelled: true, inputControl: true, sliderInput: (x) => {return x}}},
                /* {label: 'Pausenzeit', key: 'breakValue', hidden: false, type: 'numeric', min: 0, value: 30, max: 1440},
                {label: 'Skill Multiplier', key: 'skillMultiplier', hidden: true, type: '', value: 1},
                {label: 'Work Value Multiplier', key: 'workValueMultiplier', hidden: true, type: '', value: 1}, */
                {flexDivider: true, styles: {'margin-bottom': '23px'}},
            ];

            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                pointerDirection: 0,
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (updatedSkill) {
                        console.log(view, 'Edit Popup return val', updatedSkill, false);
                        view.updateEmployeeSkillValue(updatedSkill);
                    },
                    positiveButtonLabel: this.$t('global.ui.save'),
                },
                header: view.$t('pages.comp.editSkillValue'),
                width: '600px',
                remainAfterSelect: false,
                expanded: true,
            });
        },
        createEmployeeSkill(emplSkill){
            let view = this;
            let url = '/api/sec/employeeskill';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeskill');
            let payload = {
                storeId: this.$store.state.storeId,
                employeeId: this.employee.id,
            }

            payload.skillId = emplSkill.skillId;
            payload.value = emplSkill.value;


            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$helpers.success(view.$t('global.ui.createSuccessful'), view.$t('global.ui.createdX', [view.$t('pages.comp.empSkill')]));
                view.$emit('skill-added', response.data.data);
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'),error);
                console.log(error)
            })

        },
        updateEmployeeSkillValue(updatedSkill){
            let view = this;
            let url = '/api/sec/employeeskill';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeskill');
            let payload = {
                id: updatedSkill.id,
                value: updatedSkill.value,
                updateFields: ['value']
            }
            console.log(this, 'Edit SKILL payload', payload, false);
            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$helpers.success(view.$t('global.notifications.saved'), view.$t('global.ui.editedX', [view.$t('pages.comp.empSkill')]));
                view.$emit('skill-updated', updatedSkill);
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'),error);
                console.log(error)
            })

        },
        deleteEmployeeSkill(emplSkill){
            let view = this;
            let url = '/api/sec/employeeskill';

            url = this.$helpers.appendParam("id", emplSkill.id, url, '/api/sec/employeeskill');
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeskill');

            this.$helpers.log(this, 'skill to delete, url', [emplSkill, url]);
            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            }).then(response => {
                view.$helpers.success(view.$t('global.notifications.saved'), view.$t('global.ui.deletedX', [view.$t('pages.comp.empSkill')]));
                view.$emit('skill-deleted', emplSkill);
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'),error);
                console.log(error)
            })
        },
        createEmployeeAvailability(av){
            let view = this;
            let url = '/api/sec/employeeavailability';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeavailability');

            let from = av.from.format('HH:mm');
            let to = av.to.format('HH:mm');
            let state = av.state;
            let weekDays = av.weekDays;
            let employeeId = view.employee.id;
            let factor = 1;
            let comment = av.comment;
            let payload = {
                'employeeId': employeeId,
                'state': state,
                'from': from,
                'to': to,
                'factor': factor,
                'comment': comment,
                'exclusive': true,
                'weekDays': weekDays,
                'spotId': null
            };



            payload.storeId = this.$store.state.storeId;

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$helpers.success(view.$t('global.ui.createSuccessful'), view.$t('global.ui.createdX', [view.$t('pages.comp.availability')]));
                payload.id = response.data.data.id;
                view.$emit('availability-added', payload);
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'),error);
                console.log(error)
            })
        },
        updateEmployeeAvailability(av){
            let view = this;
            let url = '/api/sec/employeeavailability';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeavailability');

            let from = av.from.format('HH:mm');
            let to = av.to.format('HH:mm');
            let state = av.state;
            let weekDays = av.weekDays;
            let employeeId = view.employee.id;
            let factor = 1;
            let comment = av.comment;
            let payload = {
                id: av.id,
                'state': state,
                'from': from,
                'to': to,
                'factor': factor,
                'comment': comment,
                'exclusive': true,
                'weekDays': weekDays,
                updateFields: ['state', 'from', 'to', 'factor', 'comment', 'exclusive', 'weekDays']
            };


            payload.storeId = this.$store.state.storeId;

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {

                view.$helpers.success(view.$t('global.notifications.saved'), view.$t('global.ui.editedX', [view.$t('pages.comp.availability')]));
                view.$emit('availability-updated', av);
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'),error);
                console.log(error)
            })
        },
        deleteEmployeeAvailability(av){
            let view = this;
            let url = '/api/sec/employeeavailability';

            url = this.$helpers.appendParam("id", av.id, url, '/api/sec/employeeavailability');
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeavailability');

            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            }).then(response => {
                view.$helpers.success(view.$t('global.notifications.saved'), view.$t('global.ui.deletedX', [view.$t('pages.comp.availability')]));
                view.$emit('availability-deleted', av);
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'),error);
                console.log(error)
            })
        },
        dayNumsToDisplayString(nums){
            let days = ['',
                this.$t('store.openingHours.weekDay1Short'),
                this.$t('store.openingHours.weekDay2Short'),
                this.$t('store.openingHours.weekDay3Short'),
                this.$t('store.openingHours.weekDay4Short'),
                this.$t('store.openingHours.weekDay5Short'),
                this.$t('store.openingHours.weekDay6Short'),
                this.$t('store.openingHours.weekDay7Short')
            ];
            let str = "";
            for(let i = 0; i < nums.length; i++){
                if(i > 0) str += ", ";
                str += days[nums[i]];
            }
            return str;
        },
        avInfoDisplayStringType(av){
            let type = "";
            this.uiData.employeeAvailabilityStates.forEach(state => {
                if(state.id == av.state) type = state.label_de;
            });
            return type
        },
        avInfoDisplayStringTime(av){
            let fromTime = this.$helpers.extractTimeStringTZ(av.from);
            let toTime = this.$helpers.extractTimeStringTZ(av.to);
            return fromTime + ' - ' + toTime;
        },
        skillDetails(employeeSkill){

            this.allskills.forEach(s => {
                if(s.id == employeeSkill.skillId) return s;
                });
            return null;
        },
        skillName(employeeSkill){
            for(let i = 0; i < this.allskills.length; i++){
                if(this.allskills[i].id == employeeSkill.skillId){
                    return this.allskills[i].name;
                }
            }
            return '';
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/*
.content *:not(.main-settings)>.half {
    height: 105px;
}
*/
</style>
